
import React from 'react';

/**
 * ValidatedInput
 * Props:
 * - name, value, onChange (existing handlers expect event.target)
 * - maxLength (default 20)
 * - numericOnly (boolean)
 * - type (optional override)
 * - inputMode / pattern will be set automatically for numericOnly
 * - any other input props are forwarded
 */
const ValidatedInput = ({
  name,
  value,
  onChange,
  maxLength = 100,
  numericOnly = false,
  type,
  ...rest
}) => {
  const handleChange = (e) => {
    if (!onChange) return;
    let v = e.target.value;

    if (numericOnly) {
      // strip non-digits
      v = v.replace(/\D/g, '');
    }

    if (typeof maxLength === 'number' && maxLength > 0) {
      v = v.slice(0, maxLength);
    }

    // Shape an event-like object so existing handlers that expect e.target.value still work
    onChange({ target: { name, value: v } });
  };

  const inputProps = {
    name,
    value: value ?? '',
    onChange: handleChange,
    ...rest,
  };

  if (typeof maxLength === 'number' && maxLength > 0) {
    inputProps.maxLength = maxLength;
  }

  if (numericOnly) {
    inputProps.type = type || 'tel';
    inputProps.inputMode = 'numeric';
    inputProps.pattern = inputProps.pattern || '[0-9]*';
  } else if (type) {
    inputProps.type = type;
  }

  return <input {...inputProps} />;
};

export default ValidatedInput;
